import { create } from 'zustand';

export interface MacroMarketState {
  fearGreedIndex?: number;
  btcMarketDominance?: number;
  marketEthDominance?: number;
  lastUpdate?: Date;
  marketRegime?: string;
  marketRegimeExplanation?: string;
  setState: (newState: Partial<MacroMarketState>) => void;
}

export const useMacroMarketStore = create<MacroMarketState>((set) => ({
  fearGreedIndex: undefined,
  btcMarketDominance: undefined,
  marketEthDominance: undefined,
  lastUpdate: undefined,
  marketRegime: undefined,
  marketRegimeExplanation: undefined,
  setState: (newState: Partial<MacroMarketState>) => set(state => ({ ...state, ...newState }))
}));
